/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { all } from 'redux-saga/effects';

import auth from './auth/sagas';
import product from './product/sagas';
import category from './category/sagas';
import checkout from './checkout/sagas';
import parameter from './parameter/sagas';
import order from './order/sagas';
import { StoreState } from '../createStore';

export default function* rootSaga() {
  const response: StoreState = yield all([auth, product, category, checkout, parameter, order]);
  return response;
}
